import axios from 'axios'

export default {
    namespaced: true,
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
        add({commit, dispatch}, payload) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/mixins/comment/add',
                    payload
                ).then(({data}) => {
                    resolve(data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
    }
}
